import { protectedAxiosInstance } from 'helpers/api-calls';

const userNewsApiUrl = '/api/customer/user_role/user_news';

/**
 * Fetch user news from the API
 * @return { Promise } Promise that resolves with user news data
 */
export const fetchUserNews = () => {
  return protectedAxiosInstance.get(userNewsApiUrl);
};

/**
 * Mark user news as read
 * @param { String | Int } newsId - id of the news item
 */
export const markUserNewsAsRead = (newsId) => {
  return protectedAxiosInstance.request({
    url: `${userNewsApiUrl}/${newsId}/`,
    method: 'PUT',
    data: {
      user_news: {
        is_viewed: true
      }
    }
  });
}; 